if (!customElements.get('seo-collection-expand')) {
  customElements.define('seo-collection-expand', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.seo-collection-content__text');
      this.button = this.querySelector('button');
      this.expanded = false;
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.update();
      };
      this.button.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(() => {
        const width = this.content.getBoundingClientRect().width;
        if (width !== this.width) {
          this.width = width;
          this.measure();
        }
      });
      this.observer.observe(this.content);
      this.measure();
      document.fonts.ready.then(() => {
        if (this.isConnected) this.measure();
      });
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.button.removeEventListener('click', this.onToggle);
    }

    measure() {
      this.removeAttribute('data-collapsed');
      const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
      const limit = Number(this.dataset.limit);
      let count = 0;
      let whitespace = true;
      let endpoint;
      let node;
      while ((node = walker.nextNode())) {
        for (let index = 0; index < node.length; index++) {
          const space = /\s/.test(node.data[index]);
          if (!space || !whitespace) count++;
          whitespace = space;
          if (count === limit && !endpoint) endpoint = [node, index + 1];
        }
      }
      this.long = count > limit && Boolean(endpoint);
      if (this.long) {
        const range = document.createRange();
        range.setStart(endpoint[0], Math.max(0, endpoint[1] - 1));
        range.setEnd(endpoint[0], endpoint[1]);
        const bottom = range.getBoundingClientRect().bottom;
        const top = this.content.getBoundingClientRect().top;
        this.style.setProperty('--seo-preview-height', `${Math.ceil(bottom - top)}px`);
      }
      this.update();
    }

    update() {
      this.toggleAttribute('data-collapsed', this.long && !this.expanded);
      this.button.hidden = !this.long;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.textContent = this.expanded ? 'Ver menos' : 'Ver más';
    }
  });
}
